import { computeTrend } from "../utils";
import { CONFIG } from "./CONFIG";

// Assemble the per-topic spine from the SAME signals×topics pairs the Signals
// widget fetches: with the signal pinned to tagA, the topic is tagB. Group by
// tagB (topic), attach standalone total (tagCounts) + previous-period total +
// trend, and the top co-occurring signals (tagA) by count. Driven off the
// FULL topic set; only topics that occurred this window (total > 0) are kept.
export const assembleTopics = (topicList, cooccurrence, prevTagCounts = {}) => {
  const tagCounts = cooccurrence?.tagCounts || {};

  // Co-occurring signals per topic, from the pinned pairs (topic = tagB).
  const signalsByTopic = {};
  for (const p of cooccurrence?.data || []) {
    const id = p.tagB?._id;
    if (!id) continue;
    (signalsByTopic[id] ||= []).push({ signal: p.tagA.display, signalId: p.tagA._id, count: p.count });
  }

  return topicList
    .map((t) => {
      const id = t._id;
      const total = tagCounts[id] ?? 0;
      const prevTotal = prevTagCounts[id] ?? 0;
      return {
        topic: t.display,
        topicId: id,
        total,
        prevTotal,
        ...computeTrend(total, prevTotal, CONFIG.trendThresholdPct),
        signals: (signalsByTopic[id] || []).sort((a, b) => b.count - a.count).slice(0, CONFIG.topCooccurringSignals),
      };
    })
    .filter((t) => t.total > 0)
    .sort((a, b) => b.total - a.total);
};
